import { render, staticRenderFns } from "./SmallWinsProjects.vue?vue&type=template&id=adc8e134&scoped=true"
import script from "./SmallWinsProjects.vue?vue&type=script&lang=js"
export * from "./SmallWinsProjects.vue?vue&type=script&lang=js"
import style0 from "./SmallWinsProjects.vue?vue&type=style&index=0&id=adc8e134&prod&lang=css&scoped=true"
import style1 from "./SmallWinsProjects.vue?vue&type=style&index=1&id=adc8e134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc8e134",
  null
  
)

export default component.exports